<template>
	<div>
		<table class="datatable">
			<thead v-if="!isMobile">
			<th class="sortable active" @click="sort('subject')">
				Emne
			</th>
			<th class="sortable active" @click="sort('agreement')">
				Status
			</th>
			<th class="sortable active left" @click="sort('startdate')">
				Dato
			</th>
			</thead>
			<tbody v-if="!isMobile">
				<tr v-for="(file, index) in (sortedActivity, filteredList)" :key="index" :class="{ 'notselect' : file.status != 5}" @click="downloadFile(file)">
					<td>
						{{ showSubjectName(file) }}
						<div class="small faded">{{ showFileType(file) }}</div>
					</td>
					<td v-html="showFileStatus(file)" class="center">
					</td>
					<td>
						{{ showPrettyDate(file.startdate) }}
						<div class="small faded">{{ showGeneratedTime(file) }}</div>
					</td>
				</tr>
			</tbody>
			<tbody v-else>
				<tr v-for="(agreement, index) in (sortedActivity, filteredList)" :key="index" @click="downloadFile(file)" :class="{ 'notselect' : file.status != 5}">
					<td>
						<ul class="flex-content">
							<li data-label="Emne">
								{{ showSubjectName(file) }}
								<div class="small faded">{{ showFileType(file) }}</div>
							</li>
							<li data-label="Status" v-html="showFileStatus(file)"></li>
							<li data-label="Dato">
								{{ showPrettyDate(file.startdate) }}
								<div class="small faded">{{ showGeneratedTime(file) }}</div>
							</li>
						</ul>
					</td>
				</tr>
			</tbody>
		</table>
		<div v-if="(data && data.length > 0) && (filteredList && filteredList.length == 0) && !isComponentBusy">
			Ingen filer fundet
		</div>
		<div v-if="(data == null || data.length == 0) && !isComponentBusy">
			Der er ikke genereret nogen filer
		</div>
		<transition name="fade">
			<div class="busyloader" v-if="isComponentBusy"><div><div></div><div></div><div></div><div></div></div></div>
		</transition>
	</div>
</template>

<script>
	import { types } from "@/app/types/types";
	import { generatedFileTypeEnum } from "@/app/enums/common";
	import { generatedFileStatusEnum } from "@/app/enums/common";

	export default {
		name: "FilesList",
		data: () => ({
			data: [],
			customerID: null,
			agreementID: null,
			currentSort: "startdate",
			currentSortDir: "desc",
			searchSelection: "",
			pageSize: 10000,
			currentPage: 1
		}),
		props: ["search"],
		computed:
		{
			isMobile()
			{
				return this.$mq !== "tablethori" && this.$mq !== "desktop"
			},
			sortedActivity: function ()
			{
				// TODO: Refactor til https://vuejs.org/v2/examples/grid-component.html
				var agreements = this.data
				return agreements.sort((a, b) =>
				{
					let modifier = 1;
					if (this.currentSortDir === 'desc') modifier = -1;
					if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
					if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
					return 0;
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
			},
			filteredList()
			{
				var files = this.data
				return files.filter((data) =>
				{
					let search = this.search.toLowerCase()
					let filename = data.filename ? data.filename.toLowerCase().match(search) : "";
					//let agreementid = data.agreementid.toLowerCase().match(this.search.toLowerCase());
					return filename;
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
			}
		},
		mounted()
		{
			this.customerID = this.$route.params.customerid
			this.agreementID = this.$route.params.agreementid
			this.loadData()
		},
		methods:
		{
			showSubjectName(file)
			{
				return file.subjectname + (file.type == generatedFileTypeEnum.PERSON ? ", " + file.subjectgroupname : "")
			},
			showPrettyDate(datestring)
			{
				let date = new Date(datestring)
				var options = { year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "numeric" }
				return date.toLocaleDateString("da-dk", options)
			},
			showGeneratedTime(file)
			{
				if (file.status != generatedFileStatusEnum.RUNNING)
				{
					return "Genereret på " + file.generationtime;
				}
				else
				{
					return "Kørt i " + file.generationtime;
				}
			},
			showFileType(file)
			{
				switch (file.type)
				{
					case generatedFileTypeEnum.AGREEMENT:
						return "Aftale"
						break;
					case generatedFileTypeEnum.ALLGROUPS:
						return "Alle grupper"
						break;
					case generatedFileTypeEnum.GROUP:
						return "Gruppe"
						break;
					case generatedFileTypeEnum.PERSON:
						return "Person"
						break;
					case generatedFileTypeEnum.CUSTOMEREMAILEXPORT:
						return "Email adresser"
						break;
					case generatedFileTypeEnum.CUSTOMERLOWRESIMAGESEXPORT:
						return "Low-res billeder"
						break;
					case generatedFileTypeEnum.ORDERSDETAILS:
						return "Bestillinger"
						break;
					case generatedFileTypeEnum.DELIVERYNOTES:
						return "Følgesedler"
						break;
				}
			},
			showFileStatus(file)
			{
				switch (file.status)
				{
					case generatedFileStatusEnum.INITIAL:
						return "<span class=\"filestatus initial\">Scheduleret</span>"
						break;
					case generatedFileStatusEnum.CONFIGERROR:
						return "<span class=\"filestatus error\">Start fejl</span>"
						break;
					case generatedFileStatusEnum.RUNNING:
						return "<span class=\"filestatus running\">Kører " + file.progresspercent + "%</span>"
						break;
					case generatedFileStatusEnum.ERROR:
						return "<span class=\"filestatus error\">Fejlet</span>"
						break;
					case generatedFileStatusEnum.SUCCESS:
						return "<span class=\"filestatus finished\">Færdig</span>"
						break;
				}
			},
			async loadData()
			{
				this.setComponentAsBusy()
				const data = { customerid: this.customerID, agreementid: this.agreementID }
				await this.$store.dispatch(types.ACTION_GET_GENERATED_FILES, data)
					.then(response =>
					{
						this.data = response.data;
						this.setComponentAsIdle()
					})
					.catch(error =>
					{
						this.setAppAsIdle()
						logError("FilesList.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
					});
			},
			async downloadFile(file)
			{
				if (file.status == generatedFileStatusEnum.SUCCESS)
				{
					this.setComponentAsBusy()
					var result = await this.$store.dispatch(types.ACTION_DOWNLOAD_GENERATED_FILE, { fileid: file.id, filename: file.filename })

					if (result.status && result.status == 200)
					{
						this.setComponentAsIdle()
					}
					else
					{
						this.setComponentAsIdle()
						logError("FilesList.loadData()", result.response.error)
						alert("Der opstod en fejl ved download af filen. Prøv venligst at generer den igen.");
					}
				}
			},
			sort: function (s)
			{
				if (s === this.currentSort)
				{
					this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
				}
				this.currentSort = s;
			},
			nextPage: function ()
			{
				if ((this.currentPage * this.pageSize) < this.data.length) this.currentPage++;
			},
			prevPage: function ()
			{
				if (this.currentPage > 1) this.currentPage--;
			}
		}
	}
</script>
